import Link from '@/platform/compat/link';

export default function NotFound() {
  return (
    <div className='flex min-h-screen flex-col items-center justify-center px-4 text-center'>
      <h1 className='mb-4 text-4xl font-bold'>404 - Trang không tồn tại</h1>
      <p className='mb-8 text-gray-600'>Trang bạn đang tìm kiếm không tồn tại.</p>
      <Link
        href='/trang-chu'
        prefetch={false}
        className='rounded-lg bg-main px-6 py-3 text-white transition-colors hover:bg-main-dark'
      >
        Trở lại trang chủ
      </Link>
    </div>
  );
}
